import appLocaleData from 'react-intl/locale-data/fr';
import frMessages from '../locales/fr_FR.json';
import frMessagesVariant from '../variant/fr_FR.json';

const FrLang = {
  messages: {
    ...frMessages,
    ...frMessagesVariant,
  },
  locale: 'fr-FR',
  data: appLocaleData,
};
export default FrLang;
